module.exports = __webpack_public_path__ + "static/media/apollo.78996ddc.png";